import { render, staticRenderFns } from "./CollectionForm.vue?vue&type=template&id=ed78fd9a&scoped=true&"
import script from "./CollectionForm.vue?vue&type=script&lang=js&"
export * from "./CollectionForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionForm.vue?vue&type=style&index=0&id=ed78fd9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed78fd9a",
  null
  
)

export default component.exports